export const SET_SELECTED_DEPARTMENT_NAMES = 'SET_SELECTED_DEPARTMENT_NAMES';
export const SET_ALL_SELECTED_DEPARTMENTS = 'SET_ALL_SELECTED_DEPARTMENTS';
export const SET_SELECTED_PERIOD = 'SET_SELECTED_PERIOD';
export const RESET_SELECTED_DEPARTMENT_NAMES = 'RESET_SELECTED_DEPARTMENT_NAMES';
export const RESET_SELECTED_PERIOD = 'RESET_SELECTED_PERIOD';
export const SET_SELECTED_GROUPING = 'SET_SELECTED_GROUPING';
export const RESET_SELECTED_GROUPING = 'RESET_SELECTED_GROUPING';
export const RESET_OVERVIEW_STATE = 'RESET_OVERVIEW_STATE';
